<template>
  <div>
    <!-- <rabbey-toolbox :call-new="callNew" /> -->
    <el-row type="flex">
      <el-button-group>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="callNew"
          size="mini"
          >Nueva interacción</el-button
        >
      </el-button-group>
    </el-row>

    <rabbey-table-3
      ref="table"
      v-loading="loading"
      :data="items"
      :columns="columns"
      :actions="actions"
      @rtable-push-action="handlePushAction"
    />

    <dialog-new-interaction-form
      ref="dialogNewInteraction"
      :appendToBoddy="appendToBoddy"
      :CustomerData="CustomerData"
      @refreshInteraction="getItems"
    />
    <detailsInteractions v-bind="bindDetail" ref="detailsInteractions" />
  </div>
</template>

<script>
import detailsInteractions from "@/components/interactions/DialogInteractionDetails.vue";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
export default {
  name: "TableInteractions",
  props: ["clientCode", "CustomerData"],
  components: {
    detailsInteractions,
    "dialog-new-interaction-form": () =>
      import(
        /* webpackChunkName: "DialogNewInteractionForm" */ "@/components/interactions/DialogNewInteractionForm.vue"
      )
  },

  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      skip: 0,
      appendToBoddy: true,
      loading: false,
      unformatedDescription: [],
      bindDetail: {
        Subject: "",
        Description: ""
      },
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver Detalle",
          command: "details"
        }
      ],
      items: [],
      columns: [
        {
          prop: "InteractionType",
          label: "Tipo"
        },
        {
          prop: "ContactNo",
          label: "Contacto"
        },
        {
          prop: "UserName",
          label: "Creado por"
        },
        {
          prop: "CreatedOn",
          label: "Fecha",
          formatter: DatetimeFormatter
        },
        {
          prop: "Subject",
          label: "Asunto"
        },
        {
          prop: "Description",
          label: "Conclusión"
        }
      ]
    };
  },
  created() {
    this.getItems();
  },
  methods: {
    getItems() {
      this.loading = true;
      this.items = [];
      this.$http
        .get("/api/interactions/InteractionsCustomerDetails", {
          timeout: 100000,
          params: {
            "criteria.customerCode": this.clientCode,
            "criteria.companyId": this.currentCompany,
            "criteria.page": this.currentPage,
            "criteria.skip": this.skip,
            "criteria.limit": this.pageSize,
            "criteria.interactionTemplateCode": ""
          }
        })
        .then(({ data }) => {
          // Funcion que quita los Tags de Html
          for (const i in data.Items) {
            this.unformatedDescription.push(data.Items[i].Description);
            var str = data.Items[i].Description.replace(/(<([^>]+)>)/gi, "");
            var html = str;

            var div = document.createElement("div");
            div.innerHTML = html;
            var text = div.textContent || div.innerText || "";

            data.Items[i].Description = text;
          }
          this.items = data.Items;
          this.currentPage = data.CurrentPage;
          this.totalItems = data.ItemCount;
        })
        .catch((error) => {
          this.$message.error("Error al consultar las interacciones");
          console.error(error);
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    callNew() {
      this.$refs.dialogNewInteraction.show(this.clientCode);
    },
    handleChangePageSize(size) {
      this.pageSize = size;
      this.getItems();
    },
    handleChangeCurrentPage(page) {
      this.currentPage = page;
      this.getItems();
    },
    handlePushAction(option) {
      if (option.command == "details") {
        this.bindDetail = {
          Subject: option.row.Subject,
          Description: this.unformatedDescription[option.index]
        };
        this.$refs.detailsInteractions.show(this.bindDetail);
      }
    }
  }
};
</script>

<style></style>
